import type { ReactNode } from "react";
import { EntityFilterCombobox } from "@components/entity/EntityFilter/EntityFilterCombobox";
import { ClearFiltersButton } from "@components/pageHeader/filters/ActiveFilters/ClearFiltersButton";
import { HistoryFilters } from "@hooks/view/useHistoryPageFiltersCache";
import { TablePageHeader } from "../pageHeader/TablePageHeader";
import { ActorFilterCombobox } from "./components/ActorFilterCombobox";
import { ActivityFilterCombobox } from "./components/ActivityFilterCombobox";
import { ChannelFilterCombobox } from "./components/ChannelFilterCombobox";
import { ObjectFieldFilterCombobox } from "./components/ObjectFieldFilterCombobox";

interface HistoryLegacyToolbarProps {
    filters: HistoryFilters;
    onFiltersChange: (filters: Partial<HistoryFilters>) => void;
    defaultFilters: HistoryFilters;
    isChannelFilterEnabled: boolean;
    onClearFilters?: () => void;
    dateFilter: ReactNode;
}

/** The workspace Activity toolbar with the timeline off. */
export const HistoryLegacyToolbar = ({
    filters,
    onFiltersChange,
    defaultFilters,
    isChannelFilterEnabled,
    onClearFilters,
    dateFilter,
}: HistoryLegacyToolbarProps) => (
    <TablePageHeader
        filters={filters}
        onFiltersChange={onFiltersChange}
        defaultFilters={defaultFilters}
        isFullPage
        prependChildren={
            <>
                {dateFilter}
                <ActorFilterCombobox
                    filters={filters}
                    onChange={onFiltersChange}
                />
                {isChannelFilterEnabled && (
                    <ChannelFilterCombobox
                        filters={filters}
                        onChange={onFiltersChange}
                    />
                )}
                {onClearFilters && (
                    <ClearFiltersButton onClick={onClearFilters} />
                )}
            </>
        }
    >
        <ObjectFieldFilterCombobox
            filters={filters}
            onChange={onFiltersChange}
        />
        <ActivityFilterCombobox filters={filters} onChange={onFiltersChange} />
        <EntityFilterCombobox filters={filters} onChange={onFiltersChange} />
    </TablePageHeader>
);
